import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { ButtonGroup } from "../Button/ButtonGroup";
import { Button, Display } from "../Button/Button";


type Props = {
	clientSecret: string,
	onCancel?: () => void
}

// Needs StripeScriptLoader to use the 3rd party library 
export const PaymentDetailForm: React.FunctionComponent<Props> = ({ clientSecret, onCancel }) => {
	const stripePromise = loadStripe(window.stripeData.publishableKey);
	return (
		<div>

			<EmbeddedCheckoutProvider
				stripe={stripePromise}
				options={{ clientSecret: clientSecret }}
			>
				<EmbeddedCheckout />
			</EmbeddedCheckoutProvider>
			<ButtonGroup className="modal__actions">
				<Button key="cancel" onClick={onCancel} display={Display.Outline}>Cancel</Button>
			</ButtonGroup>
		</div>
	)
}
